/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AiFunctionExecuteRequestDto } from '../models/ai-function-execute-request-dto';
import { AiFunctionCallWithRelations } from '../models/ai-function-call-with-relations';

@Injectable({
  providedIn: 'root',
})
export class AiFunctionControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation aiFunctionControllerExecuteFunctionToolsCallByWorkflow
   */
  static readonly AiFunctionControllerExecuteFunctionToolsCallByWorkflowPath = '/ai-function/execute-function-tools-call/{id}/by-workflow';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeFunctionToolsCallByWorkflow()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunctionToolsCallByWorkflow$Response(params: {
    id: string;
    body?: AiFunctionExecuteRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionControllerService.AiFunctionControllerExecuteFunctionToolsCallByWorkflowPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeFunctionToolsCallByWorkflow$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunctionToolsCallByWorkflow(params: {
    id: string;
    body?: AiFunctionExecuteRequestDto
  }): Observable<any> {

    return this.executeFunctionToolsCallByWorkflow$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation aiFunctionControllerExecuteFunctionToolsCall
   */
  static readonly AiFunctionControllerExecuteFunctionToolsCallPath = '/ai-function/execute-function-tools-call/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeFunctionToolsCall$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  executeFunctionToolsCall$FormData$Response(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
    body?: {  }
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionControllerService.AiFunctionControllerExecuteFunctionToolsCallPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeFunctionToolsCall$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  executeFunctionToolsCall$FormData(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
    body?: {  }
  }): Observable<any> {

    return this.executeFunctionToolsCall$FormData$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeFunctionToolsCall$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunctionToolsCall$Json$Response(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
    body?: any
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionControllerService.AiFunctionControllerExecuteFunctionToolsCallPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeFunctionToolsCall$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeFunctionToolsCall$Json(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
    body?: any
  }): Observable<any> {

    return this.executeFunctionToolsCall$Json$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation aiFunctionControllerFindByIdForWorkflow
   */
  static readonly AiFunctionControllerFindByIdForWorkflowPath = '/ai-function/{id}/by-workflow';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByIdForWorkflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdForWorkflow$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<AiFunctionCallWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionControllerService.AiFunctionControllerFindByIdForWorkflowPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AiFunctionCallWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByIdForWorkflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdForWorkflow(params: {
    id: string;
  }): Observable<AiFunctionCallWithRelations> {

    return this.findByIdForWorkflow$Response(params).pipe(
      map((r: StrictHttpResponse<AiFunctionCallWithRelations>) => r.body as AiFunctionCallWithRelations)
    );
  }

  /**
   * Path part for operation aiFunctionControllerFindById
   */
  static readonly AiFunctionControllerFindByIdPath = '/ai-function/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
  }): Observable<StrictHttpResponse<AiFunctionCallWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionControllerService.AiFunctionControllerFindByIdPath, 'get');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AiFunctionCallWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
  }): Observable<AiFunctionCallWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<AiFunctionCallWithRelations>) => r.body as AiFunctionCallWithRelations)
    );
  }

  /**
   * Path part for operation aiFunctionControllerFind
   */
  static readonly AiFunctionControllerFindPath = '/ai-function';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
  }): Observable<StrictHttpResponse<Array<AiFunctionCallWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, AiFunctionControllerService.AiFunctionControllerFindPath, 'get');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AiFunctionCallWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
  }): Observable<Array<AiFunctionCallWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AiFunctionCallWithRelations>>) => r.body as Array<AiFunctionCallWithRelations>)
    );
  }

}
